import { apiClient } from '@/lib/api-client';
import type { AuthenticatedUser, LoginResponse } from '@/types/auth';

export interface LoginInput {
  email: string;
  password: string;
}

export interface MfaEnrollResponse {
  secret: string;
  otpauthUri: string;
  qrCodeDataUrl: string;
}

export const authApi = {
  async login(input: LoginInput): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/login', input);
    return data;
  },

  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/auth/logout', { refreshToken });
  },

  async getProfile(): Promise<AuthenticatedUser> {
    const { data } = await apiClient.get<AuthenticatedUser>('/auth/me');
    return data;
  },

  async enrollMfa(): Promise<MfaEnrollResponse> {
    const { data } = await apiClient.post<MfaEnrollResponse>('/auth/mfa/enroll');
    return data;
  },

  async verifyMfa(code: string): Promise<void> {
    await apiClient.post('/auth/mfa/verify', { code });
  },

  async disableMfa(code: string): Promise<void> {
    await apiClient.post('/auth/mfa/disable', { code });
  },
};
